import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import {
  normalizeAmount,
  formatData,
} from "../../../utils/transformer.util";
import { Button, Pagination, Input, Select } from "../../../components/base/index";
import language from "../../../languages";
import { TABLE_LIST_TEMA_TABLE_FIELDS } from "../../../constants/kurikulum/kurikulum.constant";

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class Anekdot_Tema extends Component {
  constructor(props) {
    super(props);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._renderButtons = this._renderButtons.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this._setForm = this._setForm.bind(this);
    this.onChangePage = this.onChangePage.bind(this);

    const { user } = this.props;
    const { organizations_id } = user;

    this.state = {
      page: 1,
      list: [],
      listAmount: 5,
      form: {
        value: {
          organizations_id: 12,
        },
        error: {
          classrooms: "",
        },
      },
      param: {},
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { id } = state.data || "";

    if (isEdit && id) {
      this.setState({ id: id });
      this._setForm(data.id);
    }

    this.handleGetData();
  }

  async handleGetData(payload = {}) {
    const { handleListTema, user } = this.props;
    const { units_id, workingUnit, id, organizations_id } = user;
    let unit_id = units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    const res = await handleListTema({
      ...payload,
      user_id: id,
      organizations_id: 12,
    });

    this.setState({
      list: res,
    });
  }

  async _setForm(id) {
    const { handleGetTema } = this.props;
    try {
      const payload = await handleGetTema({ id });
      this.setState({
        form: {
          value: {
            id: payload.id,
            name: payload.name,
            semester: payload.semester,
          },
          error: {
            // details: [],
          },
        },
      });
    } catch (err) {
      // err action
    }
  }

  _renderButtons(data) {

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
          {/* <Button onClick={() => this.onClickDelete(data)} title="Delete" /> */}
        </div>
      </td>
    );
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/kurikulum/ulangan/catatan-anekdot/tema", {
      data: val,
      isEdit: true,
    });
    history.go(0);
  }

  async onClickDelete(id) {
    const { handleDeleteTema } = this.props;
    const res = await handleDeleteTema(id);
    if (res) {
      this.handleGetData();
    }
  }

  _onFormChange(event) {
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === "number") {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === "checkbox") {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = "";
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
          },
        },
      };
    });
  }
  
  onChangePage(page) {
    const { listAmount, keywords } = this.state;
    const offset = listAmount * (page - 1);
    this.handleGetData({
      limit: listAmount,
      keywords,
      offset,
      page,
    });
  }

  async onSubmit() {
    const { history, handleSaveTema } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleSaveTema(value);
    history.push("/dashboard/kurikulum/ulangan/catatan-anekdot/tema");
    history.go(0)
  }

  async onEdit() {
    const { history, handleEditTema } = this.props;
    const { form } = this.state;
    const { value } = form;
    const res = await handleEditTema(value);
    history.push("/dashboard/kurikulum/ulangan/catatan-anekdot/tema");
    history.go(0)
  }

  render() {
    const { form, list = {} } = this.state;
    const semester = [
      { label: 'Ganjil', value: 'ganjil'},
      { label: 'Genap', value: 'genap'},
    ];
    return (
      <div className="add-budget">
        <form onSubmit={this.onSubmit}>
          <h1 style={{ color: "blue" }}>Tema Form</h1>
          <hr></hr>
          
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <Input
                label="Nama Tema"
                name="name"
                value={form.value.name}
                error={form.error.name || ""}
                onChange={this._onFormChange}
              />
            </div>
            <div className="absensi-rekap__custom-form-column__field">
              <Select
                name="semester"
                label="Semester"
                placeholder={"Pilihan"}
                onChange={this._onFormChange}
                data={semester}
                value={form.value.semester}
                error={form.error.semester || ""}
              />
            </div>
          </div>
          <div className="student-list__button">
            {this.state.id ? (
              <Button type="button" title="Update" onClick={this.onEdit} />
            ) : (
              <Button type="button" title="Simpan" onClick={this.onSubmit} />
            )}
          </div>
        </form>
        <div className="fund-request__content">
          <table className="table">
            <thead>
              <tr>
                {map(
                  TABLE_LIST_TEMA_TABLE_FIELDS.label,
                  (field, idx) => (
                    <th key={`table_th_${idx}`}>{field}</th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {map(list.result, (data, idx) => (
                <tr key={`budget_row_${idx}`}>
                  {map(
                    TABLE_LIST_TEMA_TABLE_FIELDS.value,
                    (field, fieldIdx) => {
                      if (fieldIdx === 0) {
                        return (
                          <td key={`table_index_${fieldIdx}_${idx}`}>
                            {idx + 1}
                          </td>
                        );
                      }
                      return (
                        <td
                          className={field.type === "number" ? "nominal" : ""}
                          key={`table_${fieldIdx}_${idx}`}
                        >
                          {formatData(data, field)}
                        </td>
                      );
                    }
                  )}
                  {this._renderButtons(data)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="user-management__table-footer">
          <p className="user-management__page-info">
            {`${language.translate.COMPONENT__CONTENT_TABLE__PAGE} ${list.currentPage} ${language.translate.COMPONENT__CONTENT_TABLE__OF} ${list.totalPage}`}
          </p>
          <Pagination
            totalPage={list.totalPage}
            currentPage={list.currentPage}
            onClick={this.onChangePage}
          />
        </div>
      </div>
    );
  }
}
Anekdot_Tema.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Anekdot_Tema.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
